import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';
import ReduxStore from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import selectors from '../../selectors';
import JoyrideActions from '../../actions/joyride';

const AsyncLoadable = Loadable({
    loader: () => import('./AsyncLoadable'),
    loading: () => null,
});

class MapJoyride extends Component {
    static propTypes = {
        router: PropTypes.object,
        startJoyride: PropTypes.bool.isRequired,
        dispatch: PropTypes.func.isRequired,
    };

    static mapState = (state) =>
        mapSelectors(state, {
            startJoyride: selectors.joyride.shouldStartJoyride,
        });

    static mapDispatch = (dispatch) => ({
        dispatch,
        finishJoyride: () => dispatch(JoyrideActions.finishJoyride()),
        cancelJoyride: () => dispatch(JoyrideActions.cancelJoyride()),
    });

    constructor() {
        super();
        this.state = { startPage: 1 };
    }

    _restartTourAt(startPage) {
        this.setState({ startPage });
        this._joyride.reset(true);
    }

    _progressHandler(event) {
        switch (event.type) {
            case 'step:after':
                if (event.action === 'next' && event.step.forwardSetup) {
                    event.step.forwardSetup(
                        this.props.dispatch,
                        this.props.router
                    );
                } else if (
                    event.action === 'back' &&
                    event.step.backwardSetup
                ) {
                    event.step.backwardSetup(
                        this.props.dispatch,
                        this.props.router
                    );
                }
                
                break;

            case 'finished':
                if (event.isTourSkipped) {
                    this.props.cancelJoyride();
                } else {
                    this.props.finishJoyride();
                }
                break;

            case 'error:target_not_found':
                if(event.index == 6){
                    let index = event.index + 1;
                    if(event.action == 'back') index = index -2;
                    this._restartTourAt(index);
                }else{
                    setTimeout(() => this._restartTourAt(event.index), 50);
                }
        }
    }

    render() {
        if (this.props.startJoyride) {
            return (
                <AsyncLoadable
                    setJoyrideRef={(r) => (this._joyride = r)}
                    startJoyride={this.props.startJoyride}
                    startPage={this.state.startPage}
                    progressHandler={(event) => this._progressHandler(event)}
                />
            );
        }

        return null;
    }
}

export default ReduxStore.attach(MapJoyride);



// WEBPACK FOOTER //
// ./app/components/Joyride/index.jsx